import React from 'react'
import { M_Table } from 'src/M_Components'

const Package = ({ roles }) => {
  return (
    <M_Table entityName={'package'} rolePermissions={roles} />
  )
}

export default Package